import {Normalizer, SnapshotEntity} from "../types";

// DosyaBorcluSSKCevap (uyap/DosyaBorcluSSK.ts) icin normalizer.
//
// Cevap sekli TEKIL bir isyeri/sigortali bilgisi tasir (dizi DEGIL) — bu yuzden
// normalizer en fazla TEK entity uretir (0 veya 1). Kesif notlari:
// - Anahtar "isyeri sicil no" -> sigortaliBilgi.isyeriSicil. Ayni objede ayrica
//   kisinin SGK sicil no'su olan sigortaliBilgi.sicilNo alani da var; ikisi FARKLI
//   degerlerdir, KARISTIRILMAMALI.
// - sskBilgiDetay tamamen opsiyoneldir (sonucKodu===1 "kisi bulunamadi" dalinda hic
//   set edilmeyebilir); zincirleme "?." ile okunur.
// - sskBilgiDetay.hasData bayragina GUVENILMEZ — gercek mock'ta hasData:false iken
//   sigortaliBilgi tam dolu geliyor (UYAP'in kendi ic tutarsizligi). Gercek varlik
//   testi dogrudan isyeriSicil doluluguyla yapilir.
export const sgksskNormalizer: Normalizer = (cevap) => {
    try {
        const sigortaliBilgi = cevap?.sorguSonucDVO?.sskBilgiDetay?.sgkIsyeriDVO?.sigortaliBilgi;

        const isyeriSicil = sigortaliBilgi?.isyeriSicil;
        if (typeof isyeriSicil !== "string" || isyeriSicil.length === 0) {
            return {entities: []};
        }

        const attrs: Record<string, unknown> = {};
        if (sigortaliBilgi?.isyeriUnvan !== undefined) {
            attrs.isyeriAdi = sigortaliBilgi.isyeriUnvan;
        }
        if (sigortaliBilgi?.durumKod !== undefined) {
            attrs.sigortalilikDurumKod = sigortaliBilgi.durumKod;
        }

        const entity: SnapshotEntity = {
            key: isyeriSicil,
            label: sigortaliBilgi?.isyeriUnvan || isyeriSicil,
            attrs
        };

        return {entities: [entity]};
    } catch {
        // Beklenmeyen sekil — asla throw etme, sessizce bos don.
        return {entities: []};
    }
};
